import Vue from "vue";
import Store from "./store.js";
import Router from "vue-router";
import Index from "./views/index.vue";
import RecuperarSenha from "./views/recuperar-senha.vue";
import Finalizacao from "./views/finalizacao.vue";
import NotFound from "./views/notfound.vue";
import Historico from "./views/historico.vue";
import Organizacoes from "./views/organizacoes.vue";
import Reschedule from "./views/reschedule.vue";
import scheduleRoute from "./core/routes/schedule.js";
import examRoute from "./core/routes/exam.js";
import returnRoute from "./core/routes/return.js";
import Pagamento from "@/views/pagamento.vue";
import PagamentoCartao from "@/views/pagamentoCartao.vue";
import { axiosInstance as Axios } from "@/main";
import PagamentoBoleto from "@/views/pagamentoBoleto";

Vue.use(Router);

const _isOAuthPopup = () => {
  return !!window.opener || window.name === "google" || window.name === "facebook";
};

const _hasOAuthAccessToken = hash => {
  if (!hash) {
    return false;
  }

  const params = new URLSearchParams(hash.substring(1));

  return params.has("access_token");
};

const _handleOAuth = async hash => {
  const method = sessionStorage.getItem("mol.oauthMethod");
  sessionStorage.removeItem("mol.oauthMethod");

  if (!method) {
    console.log("Não foi possível identificar o método de autenticação");
    alert("Não foi possível identificar o método de autenticação, por favor tente novamente.");

    return;
  }

  console.log("Autenticação via oauth, hash: ", hash);

  // XXX: ignorando o caractere # do início
  const params = new URLSearchParams(hash.substring(1));

  // transformando os parâmetros vindos do redirecionamento (presentes na hash)
  const oauthResponse = {};
  for (const [key, value] of params) {
    oauthResponse[key] = value;
  }

  let resp;
  try {
    resp = await Axios.post(
      `/social/auth/${method}`,
      { ...oauthResponse }
    );
  } catch (e) {
    console.error(e);

    const message = (e.response && e.response.data && e.response.data.message) || e.message;

    // detecção se o código está rodando em um popup
    if (!window.name) {
      alert("Houve um erro ao logar o usuário" + (message ? ", mensagem: " + message : ""));
    }

    return;
  }

  console.log("resposta do backend de autenticação: ", resp);

  return resp.data.token;
};

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Institution",
      component: Organizacoes,
      beforeEnter: async (to, from, next) => {
        const organizationId = parseInt(sessionStorage.getItem("mol.organizationId"));

        const redirect = () => {
          next({
            name: "index",
            params: { organizationId }
          });
        };

        if (_hasOAuthAccessToken(to.hash) && _isOAuthPopup()) {
          next();
          return;
        }

        if (organizationId && _hasOAuthAccessToken(to.hash)) {
          const token = await _handleOAuth(to.hash);

          if (token) {
            const payload = {
              organizationId,
              token,
              redirect
            };

            await Store.dispatch("login_social", payload);
            return;
          }
        }

        if (organizationId) {
          redirect();
        } else {
          next();
        }
      }
    },
    {
      path: "/oauth",
      name: "Social login",
      beforeEnter: async (to, from, next) => {
        const organizationId = parseInt(sessionStorage.getItem("mol.organizationId"));

        const redirect = () => {
          next({
            name: "index",
            params: { organizationId }
          });
        };

        if (_hasOAuthAccessToken(to.hash) && _isOAuthPopup()) {
          next();
          return;
        }

        if (organizationId && _hasOAuthAccessToken(to.hash)) {
          const token = await _handleOAuth(to.hash);

          if (token) {
            const payload = {
              organizationId,
              token,
              redirect
            };

            await Store.dispatch("login_social", payload);
            return;
          }
        }

        if (organizationId) {
          redirect();
        } else {
          next();
        }
      }
    },
    {
      path: "/index/:organizationId",
      name: "index",
      component: Index,
      beforeEnter: async (to, from, next) => {
        sessionStorage.setItem("mol.organizationId", to.params.organizationId);

        if (to.query.token) {
          Store.dispatch("login_token", {
            organizationId: to.params.organizationId,
            token: to.query.token
          });

          next({
            name: to.query.redirect || "index",
            params: { organizationId: to.params.organizationId }
          });

          return;
        }

        next();
      }
    },
    {
      path: "/recuperar-senha/form",
      name: "Recuperar Senha",
      component: RecuperarSenha
    },
    {
      path: "/historico/:organizationId",
      name: "history",
      component: Historico
    },
    {
      path: "/reagendar/:organizationId",
      name: "reschedule",
      component: Reschedule
    },
    {
      path: "/concluir/:organizationId",
      name: "finish",
      component: Finalizacao,
      beforeEnter: (to, from, next) => {
        if (!Store.getters.user) {
          Store.dispatch("set_to", to);
          Store.dispatch("set_modalLogin", true);
        }

        if (!Store.getters.get_selected.every(it => it.nome)) {
          next({
            name: "consulta_convenio",
            params: { organizationId: to.params.organizationId },
            query: to.query
          });

          return;
        }

        Store.commit("set_actualstep", 7);
        next();
      }
    },
    {
      path: "/pagamentoCartao/:organizationId",
      name: "pagamentoCartao",
      component: PagamentoCartao,
      beforeEnter: (to, from, next) => {
        if (!Store.getters.get_agendamento.id) {
          Store.commit("clear_selected");

          next({
            name: "index",
            params: to.params
          });
          return;
        }

        if (!Store.getters.user) {
          Store.dispatch("set_to", to);
          Store.dispatch("set_modalLogin", true);
        }

        Store.commit("set_actualstep", 8);
        next();
      }
    },
    {
      path: "/pagamentoBoleto/:organizationId",
      name: "pagamentoBoleto",
      component: PagamentoBoleto,
      beforeEnter: (to, from, next) => {
        if (!Store.getters.get_agendamento.id) {
          Store.commit("clear_selected");

          next({
            name: "index",
            params: to.params
          });
          return;
        }

        if (!Store.getters.user) {
          Store.dispatch("set_to", to);
          Store.dispatch("set_modalLogin", true);
        }

        Store.commit("set_actualstep", 8);
        next();
      }
    },
    {
      path: "/pagamento/:organizationId",
      name: "pagamento",
      component: Pagamento,
      beforeEnter: (to, from, next) => {
        if (!Store.getters.user) {
          Store.dispatch("set_to", to);
          Store.dispatch("set_modalLogin", true);
        }

        Store.commit("set_actualstep", 8);
        next();
      }
    },
    ...scheduleRoute,
    ...examRoute,
    ...returnRoute,
    {
      path: "/u/:hash?",
      name: "recover_session",
      beforeEnter: async (to, from, next) => {
        Store.commit("clear_selected");

        try {
          if (!to.params.hash) {
            next({ name: "Institution" });
            return;
          }

          const { data } = await Axios.get(`/u/${to.params.hash}`);

          if (data) {
            window.location.href = data.url;
          }
        } catch (err) {
          next({ name: "Institution" });
        }
      }
    },
    {
      path: "*",
      name: "notfound",
      component: NotFound
    }
  ]
});
